import { createContext, RefObject, useMemo, useRef, useState } from 'react';
import Article from '../../types/Article';

export interface ArticleContextInterface {
  activeId: string | null;
  observer: RefObject<IntersectionObserver | undefined>;
  article: Article | null;
  setArticle: (article: Article | null) => void;
  setActiveId: (activeId: string) => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const ArticleContext = createContext<ArticleContextInterface | null>(
  null,
);

interface ArticleProviderProps {
  readonly children: React.ReactNode;
}

export function ArticleProvider({ children }: ArticleProviderProps) {
  const observer = useRef<IntersectionObserver>(undefined);
  const [activeId, setActiveId] = useState('');
  const [article, setArticle] = useState<Article | null>(null);

  const value = useMemo(
    () => ({
      activeId,
      observer,
      article,
      setArticle,
      setActiveId,
    }),
    [activeId, observer, article, setArticle, setActiveId],
  );

  return (
    <ArticleContext.Provider value={value}>{children}</ArticleContext.Provider>
  );
}
